import React from 'react'
import { Box, Typography } from '@mui/material'
import EricaImage from "../../static/images/erica.jpg"

function Hero() {
  return (
    
    <Box id="Hero">
      <Box sx={{
        backgroundColor: '#5C7373', 
      }}>
        <Typography 
        align='center' 
        variant='h3' 
        sx={{ 
          color: "white", 
          fontFamily: "Light-1",
          fontSize: { 
                  xs: '1.75rem',  // Small mobile devices (0-600px)
                  sm: '2.25rem',  // Tablets (600-900px)
                  md: '2.75rem',  // Small laptops (900-1200px)
                  lg: '3rem'      // Desktops (1200px+)
                }, // Responsive font size
          }}>
            <b style={{
              color: "white", 
              textShadow: '4px 4px black'
            }}> DISTORISE </b>
        </Typography>
        <Typography align='center' variant='body2' sx={{ fontWeight:100 }}>
            <b style={{color: "#032612"}}>electronic music</b>
        </Typography>
      </Box>
      <Box sx={{
          backgroundImage: `url(${EricaImage})`,
          backgroundRepeat: 'no-repeat',
          backgroundColor: '#5864A6',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          height: 600,
          width: "100%",
          display: "flex",
          justifyContent: "center",
      }}>
          <Box sx={{
              width: "100%", // Changed to full width
              height: "89%", // Added full height
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              background: "rgba(62, 89, 79, 0.8)", // Changed to rgba for better opacity
              padding: {xs: 2, sm: 3, md: 4} // Adjusted padding
          }}>
              <Typography 
                  className="AnimatedText" 
                  variant="h4" 
                  color="#9BF2A1" 
                  align='center'
              >
                  Welcome
              </Typography>
              <Typography 
                  variant="h6" 
                  color="#9BF2A1" 
                  align='center' 
                  pt={2}
              >
                ...
            </Typography>
          </Box>
      </Box>
    </Box>
  )
}

export default Hero